import { CircularProgressProps } from "@mui/material";
import LoadingIndicator from "./LoadingIndicator";

interface LoadingOverlayProps extends CircularProgressProps {
  isLoading: boolean;
}

/**
 * A fucntion that displays a Loading Overlay in anything you put it in.
 * <Dialog>
 *  <LoadingOverlay isLoading={true}/>
 * <Dialog/>
 * @param isLoading true if you want to show the overlay
 * @constructor
 */
export default function LoadingOverlay({
  isLoading,
  ...props
}: Readonly<LoadingOverlayProps>) {
  return (
    <>
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 1000,
          }}
        >
          <LoadingIndicator {...props} />
        </div>
      )}
    </>
  );
}
